/**
 * Function for making sure data fits given schema.
 *
 * @param data Data to run check against.
 * @param Schema Yup schema.
 */
export function assertSchema<T>(data: unknown, Schema: any): asserts data is T {
  Schema.validateSync(data);
}

export function isSchema<T>(data: unknown, Schema: any): data is T {
  try {
    Schema.validateSync(data);
    return true;
  } catch (error) {
    return false;
  }
}
